// extracted by mini-css-extract-plugin
export default {"textField":"styles_textField__IJbyr","changePasswordBtn":"styles_changePasswordBtn__q1MIJ","button":"styles_button__bmpx0"};